import React, { useEffect, useRef } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { exchangeCodeForTokens } from './cognito';
import { useAuth } from './AuthProvider';

export function AuthCallback(): React.ReactElement {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const { setTokens } = useAuth();
  const called = useRef(false);

  useEffect(() => {
    if (called.current) return;
    called.current = true;

    const code = params.get('code');
    if (!code) {
      navigate('/');
      return;
    }

    exchangeCodeForTokens(code)
      .then(({ idToken, refreshToken, expiresIn }) => {
        setTokens(idToken, refreshToken, expiresIn);
        navigate('/dashboard', { replace: true });
      })
      .catch((err: unknown) => {
        console.error('Auth callback failed:', err);
        navigate('/');
      });
  }, [navigate, params, setTokens]);

  return (
    <div className="flex items-center justify-center h-screen">
      <p className="text-text-secondary">Completing sign in…</p>
    </div>
  );
}
